import { mpx } from "@didi/es-mpx-creator";
import {
  LOGIN_12306_API,
  LOGIN_OUT_12306_API,
  REGISTER_12306_API,
  FACE_VERIFICATION_12306_API,
  MESSAGE_VERIFICATION_12306_API,
  TRAIN_RETRIEVE_PASSWORD,
  TRAIN_VALIDATE_PASSWORD,
  GET_ALL_USER_ACCOUNT,
  VALIDATE_USER_ACCOUNT,
  DELETE_USER_ACCOUNT,
  REGISTER_CHANGXING_API,
} from "@/api/urls";
import { trackingInfo } from '@/common/jump';

export const getRegisterAction12306 = (data) => {
  const params = {
    ...data,
    tracking_info: trackingInfo()
  };
  return mpx.$http.post(REGISTER_12306_API, { data: params });
};
export const getLoginAction12306 = data => {
  const params = {
    ...data,
    tracking_info: trackingInfo()
  };
  return mpx.$http.post(LOGIN_12306_API, { data: params });
};

export const getLoginOutAction12306 = (data) => {
  return mpx.$http.post(LOGIN_OUT_12306_API, { data });
};

export const getFaceVerificationAction = (data) => {
  return mpx.$http.post(FACE_VERIFICATION_12306_API, { data });
};

//getMessageVerification

export const getMessageVerification = (data) => {
  return mpx.$http.post(MESSAGE_VERIFICATION_12306_API, { data });
};

export const getRetrievePassword = (data) => {
  return mpx.$http.post(TRAIN_RETRIEVE_PASSWORD, { data });
};

export const sendCaptchaResult = (data) => {
  return mpx.$http.post(TRAIN_VALIDATE_PASSWORD, { data });
};

export const getAllUserAccount = (data) => {
  return mpx.$http.post(GET_ALL_USER_ACCOUNT, { data });
};

export const validateUserAccount = (data) => {
  return mpx.$http.post(VALIDATE_USER_ACCOUNT, { data });
};

export const deleteUserAccount = (data) => {
  return mpx.$http.post(DELETE_USER_ACCOUNT, { data });
};

export const registerCxVipApi = (data) => {
  return mpx.$http.post(REGISTER_CHANGXING_API, { 
    timeout: 15000,
    data 
  });
};